import { ThemeProvider } from './ThemeProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage/HomePage';
import { CollectionPage } from './pages/CollectionPage/CollectionPage';
import { TokenInfo } from './pages/TokenInfo/TokenInfo';
import { useAppState } from './hooks/state';
function App() {
  const appData = useAppState();
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage appData={appData}/>} />
          <Route path="/collection/:publicId" element={<CollectionPage appData={appData}/>} />
          <Route path="/token/:tokenId" element={<TokenInfo appData={appData}/>} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
